import { LoggerService } from './../logger/logger.service';
import { NotificationService } from './../notification/notification.service';
import { SyncService } from './../sync/sync.service';
import { UtilsService } from './../utils/utils.service';
import { AuthService } from './../../auth/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { IonMenu } from '@ionic/angular';
import { SettingsService } from '../../settings/settings.service';
import { environment } from 'src/environments/environment';
import { CalendarVisibilitySetting } from '../shared-models/license-type.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss'],
})
export class MobileMenuComponent implements OnInit {
    isAdmin = false;
    isViewer = false;
    isBetaVersion = this.utils.isBetaVersion;
    isDevVersion = !environment.production;
    versionInfo = this.utils.versionInfo;
    showLogoutBtn = false;
    disable = false;

    possibleCalendarVisibilitySettings = CalendarVisibilitySetting;

    @ViewChild('mobileAppMenu') appMobileMenu: IonMenu;

    constructor(
        public authSrv: AuthService,
        public utils: UtilsService,
        private syncSvc: SyncService,
        private notifySvc: NotificationService,
        public settingsSrv: SettingsService,
        private logger: LoggerService,
        private translate: TranslateService
    ) {}

    ngOnInit() {
        this.authSrv.authInfoChanged$.subscribe((authInfo) => {
            if (authInfo) {
                this.isAdmin = this.authSrv.isAdminLicense;
                this.isViewer = this.authSrv.isViewerLicense;
                this.showLogoutBtn = !this.settingsSrv.getUserRights().blockMobileAppLogout;
            }
        });

        this.utils.tabLock.subscribe((lockState) => {
            this.disable = !!lockState;
        });
    }

    onLogout() {
        this.syncSvc.hasUnsyncedLocalData().subscribe({
            next: async (hasLocalData) => {
                if (hasLocalData) {
                    this.logger.log('[MOBILE MENU] Local data remains. Asking user whether to proceed.');
                    try {
                        await this.notifySvc.confirm(
                            this.translate.instant('core.sync.unsynced-data-desc'),
                            this.translate.instant('core.sync.unsynced-data-title'),
                            this.translate.instant('core.sync.unsynced-data-logout-confirm'),
                            null,
                            true
                        );

                        this.authSrv.logout();
                    } catch (promptCancel) {
                        this.logger.log('[MOBILE MENU] User cancelled on unsynced local data warning');
                    }
                } else {
                    this.logger.log('[MOBILE MENU] No local data remains. Starting logout...');
                    this.authSrv.logout();
                }
            },
            error: (err) => {
                this.logger.error('[MOBILE MENU] Error while checking remaining local data');
                this.notifySvc.error(
                    this.translate.instant('core.sync.unsynced-data-err-desc'),
                    this.translate.instant('core.sync.unsynced-data-err-title'),
                    undefined,
                    false
                );
                this.utils.sentryCaptureException(err);
            },
        });
    }

    openSupportHelpCenter() {
        try {
            (window as any).productFruits.api.inAppCenter.open();
        } catch (e) {
            this.logger.error('[MOBILE MENU] could not open support help center', e);
        }
    }

    onToggleMobileMenu() {
        this.appMobileMenu.toggle();
    }

    handleClose() {
        this.utils.triggerMobileMainMenuStatus('close');
    }

    handleOpen() {
        this.utils.triggerMobileMainMenuStatus('open');
    }
}
